import PropTypes from "prop-types";
import { SideModal } from "components/ui";
import CreateCannedResponseForm from "./CreateCannedResponseForm/CreateCannedResponseForm";
import ModalHeading from "components/ui/Modal/ModalHeading/ModalHeading";
import { MESSAGE_TAG_ACTIONS } from "../../../../enum";

const CreateCannedResponseModal = ({
    showModal,
    closeModal,
    handleSuccess,
    selectedMssgTagId,
    cannedResponse,
    currentAction,
}) => {
    return (
        <SideModal show={showModal} close={closeModal}>
            <div className='row me-0 ms-0'>
                <div className='col-10 offset-1'>
                    <ModalHeading
                        title={
                            currentAction === MESSAGE_TAG_ACTIONS.EDIT
                                ? "Edit Canned Response"
                                : "Create Canned Response"
                        }
                        subTitle={
                            currentAction === MESSAGE_TAG_ACTIONS.EDIT
                                ? "Edit response"
                                : "Create a new response"
                        }
                    />
                    <CreateCannedResponseForm
                        closeModal={closeModal}
                        selectedMssgTagId={selectedMssgTagId}
                        handleSuccess={handleSuccess}
                        cannedResponse={cannedResponse}
                        currentAction={currentAction}
                    />
                </div>
            </div>
        </SideModal>
    );
};

CreateCannedResponseModal.prototypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    handleSuccess: PropTypes.func.isRequired,
    selectedMssgTagId: PropTypes.string.isRequired,
};

export default CreateCannedResponseModal;
